module.exports = __webpack_public_path__ + "static/img/南院旅墅.b2e15d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/南院旅墅.png?20181011
// module id = kI3Y
// module chunks = 1